<template>
  <div>
    <v-row
      :class="{ 'pl-2': true, 'pr-4': true, 'cursor-pointer': true }"
      @click="showResources = !showResources"
    >
      <v-col>
        <v-card-title>
          <v-chip :color="getResourceStatusColor(resource)">{{
            getResourceStatusName(resource)
          }}</v-chip>
          <span class="subtitle-1 lighttext--text my-auto pl-4">
            {{ (resources || []).length }}
            resources
          </span>
        </v-card-title>
      </v-col>
    </v-row>
    <template v-if="showResources">
      <v-divider></v-divider>
      <v-row class="px-6">
        <v-col cols="12" v-for="(resource, i) in resources" :key="i">
          <resource-card
            :resource="resource"
            v-on:edit="showResourceDialog(resource.id)"
            v-on:delete="deleteResource(resource.id)"
          ></resource-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResourceCard from "@/components/resources/ResourceCard";
import resourceStatuses from "@/helpers/mixins/resourceStatuses";
export default {
  name: "ResourceStatus",
  components: { ResourceCard },
  props: {
    status: { type: String },
    resources: { type: Array }
  },
  mixins: [resourceStatuses],
  data: () => ({ showResources: false }),
  computed: {
    resource() {
      return this.resources[0];
    },
    ...mapGetters({})
  },
  created() {},
  methods: {}
};
</script>
